import React from 'react';
import BreadcrumbsItem from '../../components/Breadcrumbs/breadcrumbs-item';

export default function Breadcrumbs({items}) {
    return (
        <div className="breadcrumbs-items">
            {items.map((item, index) => <BreadcrumbsItem key={index} item={item} firstChild={(index === 0)} lastChild={(items.length > 1 && items.length === index +1)} />)}
        </div>
    )
}